import { Box, Button, FormikTextInput } from '@palmetto/palmetto-components';
import { Field, Form, Formik, FormikValues } from 'formik';

interface ReviewPackageFormProps {
  initialValues: any;
  onSubmit: (values: FormikValues) => Promise<void>;
  textInputDataProperty: { field: string; value: any; component?: (props: any) => React.JSX.Element } | undefined;
  flagLabel: string;
  isAccountLoading: boolean;
  isQueueLoading: boolean;
}

export const ReviewPackageForm = ({
  initialValues,
  onSubmit,
  textInputDataProperty,
  flagLabel,
  isAccountLoading,
  isQueueLoading,
}: ReviewPackageFormProps) => {
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
      {({ isSubmitting, setFieldValue, values }) => (
        <Form>
          <Box
            display="flex"
            direction={{ base: 'column', tablet: 'row' }}
            padding="lg 0 0 0"
            gap="sm"
            width={{ base: '2xl', tablet: '100' }}
            alignItems="center"
          >
            <Box>
              {textInputDataProperty?.component ? (
                <textInputDataProperty.component setFieldValue={setFieldValue} values={values} />
              ) : textInputDataProperty ? (
                <Box direction="row" gap="sm" alignItems="center">
                  <Box fontSize="md" width="100%">{`${flagLabel}:`}</Box>
                  <Field
                    hideLabel
                    name={textInputDataProperty.field}
                    id={textInputDataProperty.field}
                    placeholder="Enter new value"
                    component={FormikTextInput}
                    type="text"
                    isDisabled={isSubmitting || isAccountLoading || isQueueLoading}
                  />
                </Box>
              ) : null}
            </Box>
            <Button
              variant="primary"
              size="md"
              type="submit"
              isLoading={isSubmitting}
              disabled={isSubmitting || isAccountLoading || isQueueLoading}
            >
              Save Package
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
